function scrollStop(callback) {
  if (!callback || typeof callback !== 'function') return;

  let isScrolling;
  window.addEventListener(
    'scroll',
    () => {
      window.clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        callback();
      }, 66);
    },
    false,
  );
}

export default scrollStop;
